import { Agent } from "@/types/agent";
import { generateMistralResponse } from "./mistralService";

const validateApiKey = (key: string | null | undefined, provider: string) => {
  if (!key) {
    throw new Error(`Chave API do ${provider} é obrigatória`);
  }
  if (key.length < 20) {
    throw new Error(`Chave API do ${provider} parece inválida (muito curta)`);
  }
};

export async function generateAIResponse(message: string, agent: Agent | null) {
    try {
        if (!agent) {
            console.log('Nenhum agente ativo');
            return null;
        }

        // Validação específica por API
        switch(agent.preferredApi) {
            case 'mistral':
                validateApiKey(agent.apiKey, 'Mistral');
                return await generateMistralResponse(agent.apiKey, agent.prompt, message);
            
            case 'openai':
                validateApiKey(agent.openaiApiKey, 'OpenAI');
                const openaiResponse = await fetch('https://api.openai.com/v1/chat/completions', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${agent.openaiApiKey}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        model: 'gpt-4o-mini',
                        messages: [
                            {
                                role: 'system',
                                content: agent.prompt
                            },
                            {
                                role: 'user',
                                content: message
                            }
                        ],
                        temperature: 0.7,
                        max_tokens: 1000
                    })
                });

                if (!openaiResponse.ok) {
                    const errorText = await openaiResponse.text();
                    console.error('Erro OpenAI:', errorText);
                    throw new Error(`Erro na API OpenAI: ${openaiResponse.status} - ${errorText}`);
                }

                const openaiData = await openaiResponse.json();
                return openaiData.choices[0].message.content;

            case 'gemini':
                validateApiKey(agent.geminiApiKey, 'Google Gemini');
                const geminiResponse = await fetch('https://generativelanguage.googleapis.com/v1beta/models/gemini-pro:generateContent', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${agent.geminiApiKey}`
                    },
                    body: JSON.stringify({
                        contents: [{
                            parts: [{
                                text: `${agent.prompt}\n\nUser: ${message}`
                            }]
                        }]
                    })
                });

                if (!geminiResponse.ok) {
                    const errorText = await geminiResponse.text();
                    console.error('Erro Gemini:', errorText);
                    throw new Error(`Erro na API Gemini: ${geminiResponse.status} - ${errorText}`);
                }

                const geminiData = await geminiResponse.json();
                return geminiData.candidates[0].content.parts[0].text;

            default:
                throw new Error('Preferência de API inválida');
        }
    } catch (error) {
        console.error('Erro ao gerar resposta:', error);
        if (error instanceof Error) {
            return `Erro: ${error.message}`;
        }
        return 'Ocorreu um erro inesperado';
    }
}